const API_KEY = "9f60faa7d800829d0e88ea337cb016b8";

export default API_KEY;
